<template>
  <div class="bienvenida">
    <!-- <titulo-seccion
      :titulo="tipoPersona != 2 ? 'Bienvenido(a)' : 'Welcome'"
    ></titulo-seccion> -->
    <div class="container contenedor">
      <div class="row row-cols-lg-12 mt-3">
        <div class="col-lg-6">
          <img
            class="imagen-bienvenida"
            src="../../../../../assets/logo-bienvenida.png"
          />
        </div>
        <div class="col-lg-6">
          <h4 class="titulo-bienvenida">
            {{ (tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)  ? "¡Bienvenido(a)!" : "Welcome!" }}
          </h4>
          <p class="parrafo-bienvenida mt-4" v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
            Hola
            {{
             NombreUsuario + " " + ApellidoUsuario
            }}<br />
            ¡Estás a unos minutos de obtener tu <b>financiamiento</b>!
          </p>
          <p class="parrafo-bienvenida mt-4" v-else>
            Hello
            {{
             NombreUsuario + " " + ApellidoUsuario
            }}<br />
            You are just a few minutes away from obtaining your
            <b>financing</b>!
          </p>
          <p class="parrafo-bienvenida" v-if="(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)">
            Para continuar te solicitaremos datos personales, confidenciales y documentos relacionados con tus ingresos.<br />Para nosotros tu seguridad y la de tu información es lo más importante y está protegida y resguardada bajo nuestro aviso de privacidad.
          </p>
           <p class="parrafo-bienvenida" v-else>
            To continue we will ask you for personal and confidential data and documents related to your income.<br />For us your security and the security of your information is the most important and is protected and safeguarded under our privacy notice.
          </p>
          <div class="form-check mt-4" style="text-align: left">
            <input
              class="form-check-input bienvenida-check__acepto"
              type="checkbox"
              v-model="aceptaTerminosPrivacidad"
            />
            <label
              class="form-check-label font-weight-bold bienvenida-check__texto"
            >
              {{
                (tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)
                  ? "Acepto que he leído el "
                  : "I agree that I have read the "
              }}
              <a
                class="link-bienvenida"
                data-bs-toggle="modal"
                data-bs-target="#modalTerminosAvisos"
              >
                {{
                  (tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7) ? "aviso de privacidad." : "privacy notice."
                }}
              </a>
            </label>
          </div>
          <button
            v-if="aceptaTerminosPrivacidad"
            class="btn boton-primario boton-bienvenida"
            @click.prevent="RedirigirPantalla()"
          >
            {{ (tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7) ? "Continuar" : "Continue" }}
          </button>
          <button v-else disabled class="btn boton-primario boton-bienvenida">
            {{ (tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7) ? "Continuar" : "Continue" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "../../../Componentes/TituloSeccion.vue";
//import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import servicios from "../../../servicios/service.js";
var rutaObtenerPantalla = "/api/Master/Etapa/ConsultarVistaFlujoProspecto";
const rutaEditarProspecto = "/api/Master/Prospecto/EditarProspecto";
const rutaCargarDatosProspecto = "/api/Master/Prospecto/ObtenerProspecto";

export default {
  components: {},
  data() {
    return {
      NombreUsuario: "",
      ApellidoUsuario: "",
      tipoUsuario: null,
      tipoPersona: null,
      mostrarFooter: true,
      aceptaTerminosPrivacidad: false,
        prospecto: {
        ProspectoId: 0,
        Nombres: null,
        ApellidoPaterno: null,
        ApellidoMaterno: null,
        Telefono: null,
        Correo: null,
        montoDeseado: null,
        GeneradorId: null,
        TipoPersona: null,
        TipoInmueble: null,
        UsoInmueble: null,
        TipoUbicacion: null,
        EstadoId: null,
        PrimerAcceso: null,
        EnvioDirectoIntegracion: false,
      },
    };
  },
  async mounted() {
    this.NombreUsuario = sessionStorage.getItem("nombreUsuario");
    this.ApellidoUsuario = sessionStorage.getItem("apellidoUsuario");
    this.TipoUsuario = this.$store.getters.tipoUsuario;
    this.tipoPersona = this.$store.getters.tipoPersona;
    this.ProspectoId = this.$store.getters.prospectoId;

    await this.CargarDatosProspecto(this.ProspectoId);
  },
  methods: {
      EditarProspecto: async function(prospecto) {
      await axios.post(rutaEditarProspecto, prospecto)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.AlertaEmbajadores(resp.data.mensaje, true,false);
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true,false);
          }
        })
        .catch(e => {
           this.ManejarExcepcion(e);
        });
    },
    async CargarDatosProspecto(prospectoId){
      if(prospectoId != null){
        const parametroProspectoId = {
          params:{
            ProspectoId:prospectoId
          }
        }
        await axios.get(rutaCargarDatosProspecto, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.prospecto.ProspectoId = resp.data.data.prospectoId;
            this.prospecto.Nombres = resp.data.data.nombres;
            this.prospecto.ApellidoPaterno = resp.data.data.apellidoPaterno;
            this.prospecto.ApellidoMaterno = resp.data.data.apellidoMaterno;
            this.prospecto.GeneradorId = resp.data.data.generadorId;
            this.prospecto.Telefono = resp.data.data.telefono;
            this.prospecto.Correo = resp.data.data.correo;
            this.ProyectoId = resp.data.data.proyectoId;
            this.prospecto.TipoPersona = resp.data.data.tipoPersona;
            this.prospecto.montoDeseado = resp.data.data.montoDeseado;
            this.prospecto.TipoPersona = resp.data.data.tipoPersona;
            this.prospecto.TipoInmueble = resp.data.data.tipoInmueble;
            this.prospecto.UsoInmueble = resp.data.data.usoInmueble;
            this.prospecto.TipoUbicacion = resp.data.data.tipoUbicacion;
            this.prospecto.EstadoId = resp.data.data.estadoId;
            this.prospecto.PrimerAcceso = resp.data.data.primerAcceso;
          }
        }).catch((e) => {
          this.ManejarExcepcion(e);
        });
      }
    },

    async RedirigirPantalla() {
      let tipoPersona = this.tipoPersona;
      let prospectoId = this.ProspectoId;

      if(!this.aceptaTerminosPrivacidad)
      {
        this.AlertaEmbajadores( "Debe aceptar los términos y condiciones de privacidad", false,false);
        return;
      }
      if(this.ProspectoId != null) await this.EstablecerPrimerAccesoProspecto(this.ProspectoId);

      this.$store.commit("setAvisoPrivacidadAceptado", true);
      sessionStorage.setItem("primerAcceso", false);
     
      const parametroProspecto = {
        params: {
          prospectoId: prospectoId,
        },
      };
      axios
        .get(rutaObtenerPantalla, parametroProspecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            if (resp.data.data != "") {
              let pantalla = resp.data.data;
              if (
                pantalla == "PreAutorizacion" &&
                (this.TipoUsuario == 4)
              ) {
                this.$router.push({
                  name: pantalla,
                });
              } else if (
                (this.TipoUsuario == 3 && pantalla == "PreAutorizacion") ||
                ((this.TipoUsuario == 1) &&
                  pantalla == "PreAutorizacion")
              ) {
                this.AlertaEmbajadores(
                  servicios.CrearMensaje(
                    this.TipoUsuario,
                    tipoPersona,
                    pantalla
                  ),
                  true,
                  (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false
                );
              } else if (
                (this.TipoUsuario == 3 &&
                  pantalla == "GenerarInformacionDePago") ||
                ((this.TipoUsuario == 1 || this.TipoUsuario == 6 || this.TipoUsuario == 9) &&
                  pantalla == "GenerarInformacionDePago")
              ) {
                this.AlertaEmbajadores(
                  servicios.CrearMensaje(
                    this.TipoUsuario,
                    tipoPersona,
                    pantalla
                  ),
                  true,
                  (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false
                );
              } else if (
                (this.TipoUsuario == 3 && pantalla == "ValidarPago") ||
                ((this.TipoUsuario == 1 || this.TipoUsuario == 6 || this.TipoUsuario == 9) &&
                  pantalla == "ValidarPago")
              ) {
                this.AlertaEmbajadores(
                  servicios.CrearMensaje(
                    this.TipoUsuario,
                    tipoPersona,
                    pantalla
                  ),
                  true,
                  (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false
                );
              } else if (
                (this.TipoUsuario == 1 &&
                  pantalla == "CargarInformacionDePago") ||
                (this.TipoUsuario == 4 &&
                  pantalla == "CargarInformacionDePago") ||
                (this.TipoUsuario == 5 &&
                  pantalla == "CargarInformacionDePago") ||
                (this.TipoUsuario == 6 && 
                  pantalla == "CargarInformacionDePago") ||
                (this.TipoUsuario == 9 && 
                  pantalla == "CargarInformacionDePago")
              ) {
                this.AlertaEmbajadores(
                  servicios.CrearMensaje(
                    this.TipoUsuario,
                    tipoPersona,
                    pantalla
                  ),
                  true,
                  (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false
                );
              } else if (
                (this.TipoUsuario == 1 || this.TipoUsuario == 6 || this.TipoUsuario == 9) &&
                pantalla == "CajaDorada"
              ) {
                this.AlertaEmbajadores(
                  "El prospecto ya se encuentra contratado y tiene acceso a su Kit de Bienvenida.",
                  true
                );
              } else if (
                (this.TipoUsuario == 1 || this.TipoUsuario == 3) &&
                pantalla == "SeguimientoProspecto"
              ) {
                this.AlertaEmbajadores(
                  servicios.CrearMensaje(
                    this.TipoUsuario,
                    tipoPersona,
                    pantalla
                  ),
                  true,
                  (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false
                );
              } else {
                this.$router.push({ name: pantalla });
              }
            } else {
              this.AlertaEmbajadores(resp.data.mensaje);
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../assets/estilos/estilosgenerales.scss";
.bienvenida {
  width: 100vw;
  flex-grow: 1;
}
.bienvenida-check__acepto {
  font-size: 18px;
}
.bienvenida-check__texto {
  font-size: 18px;
  color: black;
}
</style>
